import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { FaChevronLeft } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Grid } from '@mui/material'
import { Edit } from '@mui/icons-material'

import { Form, Formik } from 'formik'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import InputField from 'components/atoms/fields/InputField'

import formModel, { initialValues, validationSchema } from 'utils/formModels/setupConstantModel'
import { crudColorMap, crudIconMap } from 'utils/helpers'
import useCrudData from 'utils/customHooks/useCrudData'
import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { useSuccessAlert } from 'utils/customHooks/useSuccessAlert'
import CheckboxField from 'components/atoms/fields/CheckboxField'

interface IProps {
  type: string
  entity: any
  enableMutation: any
  disableMutation: any
}

const SetupConstantForm: FC<IProps> = ({
  entity, 
  enableMutation,
  disableMutation
}) => {
  const { t } = useTranslation()



  const [
    enableEntity,
    { isLoading: enableLoading, isSuccess: enableSuccess, error: enableError, data: enableData },
  ] = enableMutation()

  const [
    disableEntity,
    { isLoading: disableLoading, isSuccess: disableSuccess, error:  disableError, data: disableData },
  ] = disableMutation()

  const isLoading = enableLoading || disableLoading
  const error = enableError || disableError
  const success = enableSuccess || disableSuccess

  useErrorAlert(error)
  useSuccessAlert(success ? t('alerts.setup-updated') : '')

  const {
    title,
    is_active,
  } = formModel()
  
  return (
    <Formik
      enableReinitialize
      initialValues={entity}
      validationSchema={validationSchema}
      onSubmit={(values: any) => {

        if(values?.is_active){
          enableEntity({id: entity.option, body: {
            custom_title: values?.title
          }})
        }else{
          disableEntity(entity.option)
        }

      }}
    >
      <Form>
        <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>
          <Grid item xs={12} md={8}>
            <InputField fieldProps={{...title}}  />
          </Grid>
          <Grid item xs={8} md={2}>
            <CheckboxField fieldProps={{...is_active}} />
          </Grid>
          <Grid item xs={4} md={2}>
            <SubmitButton
                color={'success'}
                text={`${t('common.save')}`}
                sx={{ width: '10rem' }}
                isLoading={isLoading}
              />
          </Grid>
        </Grid>
      </Form>
    </Formik>
  )
}
export default SetupConstantForm
